<template>
  <section>
    <social-header title="用户服务协议"></social-header>
    <div class="protocol-page">
      <h4>汽车之家亲友团用户注册协议</h4>
      <p>
        本《汽车之家亲友团用户注册协议》（以下简称“本协议”）是由亲友团用户（下称“会员”或“您”）与汽车之家签订的关于使用汽车之家亲友团平台（下称“本平台”）的法律协议。
      </p>
      <p>
        为保障会员的合法权益，请于注册成为亲友团成员前，仔细阅读本协议所有内容。注册或使用本服务时，即表示已充分阅读、理解并同意接受本协议及汽车之家平台公示的相关规则制度之所有内容。当您通过在线勾选或点击网络页面的按钮时，即表示您已仔细阅读本协议全部条款并同意接受本协议约束，包括但不限于本协议和不时发布的公告、通知、规范等。如果您不同意接受本协议的内容，请不要进行后续操作。
      </p>
      <h4>资质确认</h4>
      <p>请您在此确认，同意本协议时，您符合如下所有条件:</p>
      <p>满18周岁，具备完全民事行为能力；</p>
      <p>
        如不符合上述任一条件，或在履行合同过程中，出现不符合上述任一条件的情况，本平台有权随时终止合作。
      </p>
      <h4>一、定义</h4>
      <p>
        1.
        汽车之家：天津车之家软件有限公司（注册地址：天津生态城动漫中路126号动漫大厦C区二层209），以下简称“汽车之家”；
      </p>
      <p>
        2. 运营方：指汽车之家负责网站、应用程序或在线平台的运营管理人员；
      </p>
      <p>
        3.
        亲友团成员平台：指由天津车之家软件有限公司所有，由运营方提供推广及营销技术服务的平台以下简称“本平台”；
      </p>
      <p>
        4.
        推广渠道：拥有和/或具有合法运营权、代理权的互联网信息发布空间，包括但不限于符合国家规定的网站、网页、界面和/或即时通讯软件、及社交媒体等；
      </p>
      <p>
        5.
        有效报名：指用户通过点击本平台会员投放的推广链接，访问对应的服务页面并首次成功提交真实有效的用户信息（包括但不限于姓名、手机号码）。同一服务页面多次报名，仅一次有效。
      </p>
      <p>
        6.
        有效到店：指用户通过点击本平台会员投放的推广链接，产生有效报名后，根据报名信息前往指定的活动地点参加活动并完成真实有效的签到。
      </p>
      <p>
        7.
        有效成交：指用户通过点击本平台会员投放的推广链接，访问对应的商品/服务页面，购买商品/服务，确认收货/服务完成并支付费用，且依法于无理由退换货期间没有产生退货的。
      </p>
      <p>
        8.
        有效操作：指用户通过点击本平台会员投放的推广链接，访问对应的服务页面完成下载、登陆注册、线上体验等行为。
      </p>
      <p>
        9.
        服务费比例：指在本协议项下平台会员投放推广链接，达到指定的推广效果后，运营方向平台会员支付服务费所依据的比例。包括但不限于类目服务费比例、活动服务费比例、商品服务费比例等，本平台另有规定的除外。
      </p>
      <p>
        10.
        推广效果：指平台单次推广活动内页描述的任务达成方式及对有效报名、有效到店、有效成交、有效操作的具体约定，推广效果标准由本平台根据单次活动具体约定。
      </p>
      <p>
        11.
        有效推广：指本平台会员通过拜访汽车之家车商客户进行汽车之家产品/服务的推广宣传，实现客户与汽车之家签署合作协议并支付费用。
      </p>
      <p>
        12.
        在履行本协议过程中，会员向汽车之家提供的所有信息均已取得了信息所有人的同意/许可/确认/授权，不存在擅自出售、提供或非法获取个人信息的行为。汽车之家在与信息所有人沟通时，将确认此事项，如发现您提供的信息存在未经信息所有人的同意/许可/确认/授权，汽车之家将即时终止本协议。
      </p>
      <h4>二、汽车之家的权利与义务</h4>
      <p>
        1.
        按照税法规定，基于会员提现、运营方报税需求，汽车之家有权要求会员提供包括但不限于身份证号码、手机号码、银行卡号等个人信息，及任何运营方认为必要的相关材料；汽车之家按照税法规定为个人申报个人所得税，由天津车之家软件有限公司负责申报，如对报税公司名称不了解是否为汽车之家主体，可联系平台客服；
      </p>
      <p>
        2．运营方有权对会员进行不限于短信、电话等方式进行活动告知、中奖通知，通话来源汽车之家、家家亲友团或集团公司（平安旗下公司）
      </p>
      <p>
        3. 运营方有权随时对会员履行本协议的情况进行检查和监督，会员应积极配合；
      </p>
      <p>
        4.
        运营方应在会员依本协议约定的方式对本平台的商品/服务进行推广，满足本协议项下条件时，依据本协议或平台规则规定的计算方式和支付方法向会员支付服务费。
      </p>
      <p>
        5.
        运营方有权依据下述情况取消会员资格、禁用账号、扣发服务费并追究会员相应责任：
      </p>
      <p>
        A.
        会员违法法律、法规规定及本平台规则，对本平台造成不良影响；以平台员工/代理人的名义对外宣传;
      </p>
      <p>B. 会员提供虚假、不完备信息的；进行虚假宣传、误导用户/客户；</p>
      <p>
        C. 会员引导用户/客户作弊（包括但不限于刷单、伪造信息）骗取平台服务费的；
      </p>
      <p>
        D. 通过非法渠道收集获取用户/客户信息，或将用户/客户信息用于非法目的；
      </p>
      <p>
        E.
        会员及会员向平台反馈的用户/客户在汽车之家及其关联公司信控管理系统中被标记为异常状态的；
      </p>
      <p>F. 会员的推广信息中含有下列内容的：</p>
      <p>
        1)
        宣扬色情、暴力，基于种族、性别、宗教信仰、国籍、残疾、性倾向或年龄的歧视；
      </p>
      <p>
        2)
        宣扬任何非法的、有害的、威胁性的、诽谤的、骚扰的或其他易引起反感的行为；
      </p>
      <p>
        3) 侵犯任何第三方（含运营方关联公司）知识产权、公众形象或隐私的内容；
      </p>
      <p>4) 其他违反中国法律法规规定或公序良俗的内容。</p>
      <h4>三、会员的权利与义务</h4>
      <p>
        1.
        会员声明并保证，其具有签署并履行本协议所应具备的一切资质与能力，系具有完全民事行为能力的自然人。会员应按照本平台要求进行注册，并就上述声明与保证提供相关证照及其他证明文件。
      </p>
      <p>
        2.
        会员有权在本平台自主选择商品服务进行推广，并在其推广渠道中投放本平台推广链接。会员应按照本平台要求并以运营方认可的方式在网络上投放本平台推广链接。未经运营方许可，不得随意修改、篡改平台的推广链接。
      </p>
      <p>
        3.
        运营方授权会员在本协议有效期内仅为履行本协议之目的合理使用从本平台获取的图形和/或文本。平台会员不得以任何可能对运营方及运营方关联公司的商誉造成负面影响的方式或任何对用户造成误导的方式使用/修改运营方图形或文本。
      </p>
      <p>
        4.
        会员不得以任何方式就会员与运营方或运营方关联公司的关系对外发布虚假或误导性的信息或者允许该等虚假或误导的信息在其推广渠道中存在。若会员违反此项约定，运营方有权要求会员在运营方要求的时间内予以纠正，否则，运营方有权立即单方解除本协议并取消会员资格，并有权要求会员返还其已收到的全部服务费并拒绝支付全部未发放的服务费作为会员违约金，同时，若因此给运营方/运营方关联公司造成任何损失，运营方有权要求会员承担全部赔偿责任。
      </p>
      <p>
        5.
        会员应仅在经运营方确认的推广媒介进行投放，不得采取包括但不限于制作、安装木马程序等作弊手段进行推广。
      </p>
      <p>
        6.
        会员了解并同意，本平台有权随时对会员各项权限进行管理、调整，包括但不限于关闭已开通权限、开通其他功能的使用权限等。
      </p>
      <h4>四、费用及支付</h4>
      <p>1. 服务费</p>
      <p>
        A.
        运营方同意按照平台指定的合作模式对会员推广产生的有效订单向会员支付服务费。
      </p>
      <p>
        B.
        服务费的金额按照运营方统计的满足推广效果的用户或客户有效行为对应的付费基数或有效交易发生的商品的净销售额（即用户/客户实际支付的销售金额），包含以下计算方式：
      </p>
      <p>单笔服务费=单笔活动付费基数*服务费比例</p>
      <p>单笔服务费=单笔商品净销售额*服务费比例</p>
      <p>单笔服务费=单笔订单合同回款金额*服务费比例</p>
      <p>单笔服务费=单笔订单合同约定的固定金额</p>
      <p>
        具体服务费比例以平台公告为准。会员理解并确认，因本平台业务类型不同以及业务发展，运营方有权对服务费的计算公式及服务费比例进行调整并以公告形式告知，会员应关注本平台公告内容。
      </p>
      <p>
        C.
        只有基于用户/客户的自愿真实有效行为才能作为计算会员服务费的依据。“有效报名”、“有效到店”、“有效成交”、“有效操作”、“有效推广”是指同时符合下列所有条件要求的行为：
      </p>
      <p>
         用户/客户通过会员推广渠道上设立的推广链接访问商品/服务页面；
      </p>
      <p>
        
        用户/客户在上述访问的页面内或汽车之家业务平台，产生了平台指定的有效行为/有效交易；
      </p>
      <p> 订单完成且在有效退换货期限内未发生任何退换货行为。</p>
      <p>D. 以下情况将影响服务费的计算或不予计算服务费：</p>
      <p>
         用户通过积分、优惠券、抵扣券等非现金支付的部分不计算服务费；
      </p>
      <p> 刷单、作弊类订单不予计算服务费；</p>
      <p> 未达推广效果标准的订单不予计算服务费。</p>
      <p>2. 支付</p>
      <p>A. 除本平台另有规定外，每月1-5日为会员申请提现日。</p>
      <p>
        B.
        会员知悉并确认，如若应付会员的服务费不足10元，运营方将于应付服务费累积至10元以上时于提现日支付。
      </p>
      <p>
        C.
        若会员在申请提现日没有申请提现，则当期款项可累积至下个提现日，非提现日不能申请提现。
      </p>
      <p>
        D.
        请务必按照规定填写相应的银行信息并保持更新，因信息错误或不符合银行、本平台规定而导致的支付延期或失败，会员应自行承担全部后果。
      </p>
      <p>
        E.
        运营方有权根据业务需要对服务费的结算事项、提现日期、支付方式等进行变更，届时将在本平台以公告形式公布，请会员实时关注本平台公告内容。
      </p>
      <h4>五、安全条款</h4>
      <p>
        1.
        汽车之家会根据合法、正当、必要、透明的原则，基于本政策所述的目的，收集和使用您的个人信息。如果我们将您的个人信息用于本政策未载明的其它用途或基于其他特定目的，我们将以合理的方式告知您，并在收集、使用前再次征得您的同意。
      </p>
      <p>
        2.
        会员应妥善保管其亲友团成员账户、密码和汽车之家提供的一切安全产品，不向其他任何人透露或允许使用上述安全信息。由于会员原因导致上述安全信息被他人知悉或使用，进而造成损失的，汽车之家不承担任何责任。
      </p>
      <p>
        3.
        当会员发现其亲友团账户、密码等信息泄露、遗失或被第三人冒用、盗用等其他任何未经合法授权的异常情形的，应立即通知汽车之家，并按照本网站提示向汽车之家提交必要证明资料以便汽车之家及时确认。在确认上述事实前，会员账户已发生的登录或交易结果均须由会员独自承担，除非可证明汽车之家对上述安全信息之泄露、遗失及未经合法授权之情形存在故意或重大过失。若会员延迟通知或不按照本网站提示提交资料的，则汽车之家对延迟期间产生的损失不承担任何责任。
      </p>
      <p>
        4.
        如果会员不小心泄漏了密码，请立即登录亲友团账户更改密码。设置的密码应方便记忆而不易破解，避免选择一些显而易见的词或者日期，比如：英文名字、出生日期、电话号码等。
      </p>
      <p>
        5.尽量不要把在其他网站的密码用在这里，在多个网站使用同一密码，会提高输入同一密码的几率，这样密码就很容易被别人窃取。
      </p>
      <h4>六、协议变更及终止</h4>
      <p>
        1.
        运营方有权根据自身业务状况不时地合理变更推广合作方式、本协议条款及平台规则。
      </p>
      <p>
        2.
        本协议终止后，双方应尽快对本协议项下应付未付的服务费进行清算。运营方应向会员支付本协议有效期内产生的，根据本协议规定的标准计算的服务费。运营方有权在协议终止后90日内保留应付服务费以确保支付金额的准确性，会员须在本协议终止满90日后的30日内与运营方进行未付的服务费的清算，逾期未清算的，则视为会员放弃未清算服务费的债权，运营方有权不再承担任何清算与支付义务。
      </p>
      <h4>七、免责条款与赔偿范围</h4>
      <p>
        1.
        因不可抗力或汽车之家不能控制的原因导致会员无法使用本服务或造成损失的，汽车之家不承担任何责任，但将尽力减少损失和影响。上述不可抗力与汽车之家不能控制的原因包括但不限于以下情形：
      </p>
      <p>a) 台风、地震、海啸、洪水、战争等；</p>
      <p>b) 黑客攻击、计算机病毒侵入或发作；</p>
      <p>
        c) 计算机系统遭到破坏、瘫痪或无法正常使用而导致信息或记录的丢失等的；
      </p>
      <p>d) 电信部门技术调整导致之重大影响；</p>
      <p>e) 电信机线设备原因以致发生错误、迟滞中断或不能传递；</p>
      <p>f) 因政府管制而造成的暂时性关闭等；</p>
      <p>
        g)
        出于会员与交易相对方、银行、电信、网络、设备及供电故障等其他不可抗力或其他不可归责于汽车之家的事由。
      </p>
      <p>
        2.
        会员了解并认可，使用本服务将存在一定的风险，该等风险包括但不限于：账户和密码被他人冒用、盗用、或有其他任何未经合法授权之情形发生；或不法分子盗用银行卡等。这些风险均会造成经济损失，除非可证明汽车之家对损失的形成存在故意或重大过失，汽车之家将不承担任何责任。
      </p>
      <p>
        3.
        会员同意，使用本服务所存在的风险及后果将完全由其独自承担，汽车之家对会员的系统操作及其影响不承担任何责任。
      </p>
      <p>
        4.
        汽车之家不保证本网站设置的外部链接的准确性和完整性，也不对该等外部链接指向的不由汽车之家实际控制的任何网页上的内容承担任何责任。
      </p>
      <p>
        5. 汽车之家不对本服务提供任何形式的保证，包括但不限于以下事项：
        本服务完全符合会员的需求； 本服务不受干扰、及时提供或免于出错。
      </p>
      <h4>八、违约责任</h4>
      <p>
        1. 如果会员违反有关法律、法规或本协议项下的任何条款而给汽车之家或任何
        第三方造成损失的，应承担由此造成的损害赔偿责任包括但不限于行政处罚、名
        誉损失、直接和间接经济损失及协议履行后的预期利益、律师费、诉讼费等。
      </p>
      <p>
        2. 如果汽车之家违反本协议约定致使会员的资料对外泄露的，汽车之家将赔偿
        因此所造成的直接经济损失，并且将采取积极的办法做出补救；如果会员违反本
        协议约定致使其或本网站其他用户的资料被他人获取、破坏、对外泄露的，会员
        应当赔偿汽车之家因此遭受的直接经济损失。
      </p>

      <h4>九、法律适用与管辖法院</h4>
      <p>
        本协议的订立、效力、解释、履行和争议的解决等均适用中华人民共和国法律，并应以海淀区人民法院为一审管辖法院。
      </p>
      <h4>十、其他事项</h4>
      <p>
        1.
        本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。除非经汽车之家书面同意，会员无法转移任何权利和义务；
      </p>
      <p>
        2.
        不论本协议中的任何条款因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力；
      </p>
      <p>
        3.
        本协议与纸质服务协议（如有）具有同等法律效力。如本协议与纸质服务协议约定不一致的，优先适用纸质服务协议的约定；
      </p>
      <p>
        4.
        若会员在使用亲友团账户的同时还涉及到汽车之家的其它产品或服务的，同时还须遵守汽车之家其它产品和服务的规定；
      </p>
      <p>
        5.
        汽车之家可能随时修改完善本协议内容和平台相关政策，会员注册并申请或登录使用本服务，视为同意遵守本平台发布的最新的协议和政策。
      </p>
    </div>
  </section>
</template>
<style type="text/css">
.protocol-page {
  background: #fff;
  padding: 0.44444rem;
}
.protocol-page h4 {
  color: #000;
  font-weight: bold;
  line-height: 1.4rem;
}
.protocol-page p {
  color: #000;
  margin-bottom: 0.44444rem;
  opacity: 0.85;
  line-height: 1.3rem;
}
</style>
<script>
import SocialHeader from "../../components/social-header.vue";
export default {
  components: {
    SocialHeader
  },
  name: "AccountLogin",
  data: function() {
    return {};
  },
  created: function() {},
  mounted: function() {},
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/pages/account/protocal.vue